import { render, staticRenderFns } from "./checkboxes.vue?vue&type=template&id=4c624845&"
import script from "./checkboxes.vue?vue&type=script&lang=ts&"
export * from "./checkboxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports